// extracted by mini-css-extract-plugin
export default {"root":"html-select_root__fmyAN","placeHolderShimmer":"html-select_placeHolderShimmer__Fyq+-"};